import { bookmarksActions } from '@redux/slices/bookmarks';
import { store } from '@redux/store';
import { getAppDispatch } from '@utilities/dispatch.util';

const bookmarksJsonManipulationJson = ({ initialLogin, data }) => {
  const bookmarks = store.getState()?.bookmarks?.bookmarks || [];
  const { items = [] } = data;

  if (initialLogin && bookmarks?.length > 0) {
    const newBookmarks = bookmarks?.filter((x) => !x?.sync) || [];
    const editedBookmarks = bookmarks?.filter((x) => x?.update) || [];

    let storeData = [...newBookmarks, ...editedBookmarks];

    let modifiedItems = items?.map((x) => {
      return { ...x, sync: true };
    });

    let newList =
      modifiedItems?.length > 0
        ? modifiedItems?.filter((item) => {
            return !editedBookmarks?.some((x) => x?.bookmarkId === item.bookmarkId) ? true : false;
          })
        : [];

    newList = [...newList, ...storeData];

    return newList;
  } else {
    return (
      items?.map((x) => {
        return { ...x, sync: true };
      }) || []
    );
  }
};

const bookmarksDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(
    bookmarksActions.setBookmarks({
      bookmarks: data
    })
  );
};

export { bookmarksJsonManipulationJson, bookmarksDispatcher };
